import React from 'react'
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import AppCtx from '../app_context';
import { BLUE, GRAY, RED } from '../../style/colors';

export const MaterialContext = React.createContext()


export default function Material(props) {
  const { user } = React.useContext(AppCtx)
  const [primary, setPrimary] = React.useState('#1b50a6')
  const [secondary, setSecondary] = React.useState('#FFFFFF')

  let primary_theme = primary
  let secondary_them = secondary

  // over ride state coloe with user Theme from allegiance
  if (user) {
    switch (user.allegiance) {
      case 'American':
        primary_theme = BLUE
        break
      case 'British':
        primary_theme = RED
        break
      default:
        primary_theme = GRAY
        break
    }
  }

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: primary_theme,
      },
      secondary: {
        main: secondary_them,
      },
    },
  });

  return <ThemeProvider theme={theme}>
    <MaterialContext.Provider value={{
      setPrimaryTheme: setPrimary,
      setSecondaryTheme: setSecondary,
    }}>
      {props.children}
    </MaterialContext.Provider>
  </ThemeProvider>
}